import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { APIBaseService } from './api_base.service';
import { domain } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccessRoleAPIService extends APIBaseService {
  namespace = 'accessRole';
  async getAccessRights(json = {}) {
    const params = json || {};
    const options = { ...this.getHeader(), params };
    const url = `${domain}/accessRight/list`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async list(json = {}) {
    const params = json || {};
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/list`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async listUser(json = {}) {
    const params = json || {};
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/listUser`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async add(data:any) {
    const url = `${domain}/${this.namespace}/add`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async get(id:any) {
    const url = `${domain}/${this.namespace}/${id}/get`;
    return this.http.get(url, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async update(id:any, model:any) {
    const url = `${domain}/${this.namespace}/${id}/update`;
    return this.http.post(url, model, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async addRight(id:any, model:any) {
    const url = `${domain}/${this.namespace}/${id}/addRight`;
    return this.http.post(url, model, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  
  async deleteRight(id:any, accessRoleRightId:any) {
    const url = `${domain}/${this.namespace}/${id}/${accessRoleRightId}/deleteRight`;
    return this.http.get(url, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async create(data:any) {
    const url = `${domain}/access/createUser`;
    return this.http.post(url, {data}, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async getUser(id:any) {
    const url = `${domain}/${this.namespace}/${id}/getUser`;
    return this.http.get(url, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async updateUser(data:any) {
    const url = `${domain}/access/updateUser`;
    return this.http.post(url, {data}, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
}
